import React, { ReactNode } from "react"
import H2 from "../../atoms/typography/H2"
import { Col, Row } from "react-grid-system"
import Body from "../../atoms/typography/Body"
import { HorizontalSpacer } from "../../atoms/spacers"
import styled from "styled-components"
import { MediaQuery } from "../../../utils/design-helpers"

type Props = {
  formTitle: string
  formDescription1: string
  formDescription2: string
  children: ReactNode
}

const ContentWidth = styled.div`
  max-width: 40vw;
  align-items: center;

  ${MediaQuery.XS} {
    max-width: none;
  }
`

export const FormModalContent: React.FC<Props> = ({ formTitle, formDescription1, formDescription2, children }) => {
  return (
    <Row justify="center">
      <ContentWidth>
        <Col>
          <H2 textAlign="center">{formTitle}</H2>
          <HorizontalSpacer spacing={2} />
          <Body textAlign="start">{formDescription1}</Body>
          <HorizontalSpacer spacing={0.5} />
          <Body textAlign="start">{formDescription2}</Body>
          <HorizontalSpacer spacing={2} />
          {children}
          <HorizontalSpacer spacing={1.5} />
        </Col>
      </ContentWidth>
    </Row>
  )
}
